import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
`;

export const Title = styled.h2`
  color: #4a4a4a;
  margin: 0;
  font-size: 18px;
  font-weight: 500;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const SendAllButton = styled.button`
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3367d6;
  }

  &:disabled {
    background-color: #a9a9a9;
    cursor: not-allowed;
  }
`;

export const ScheduleButton = styled(SendAllButton)`
  background-color: #e0e0e0;
  color: #5f6368;

  &:hover {
    background-color: #d2d2d2;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 20px;
  position: relative;
`;

export const SearchInput = styled.input`
  padding: 10px 16px 10px 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 300px;

  &:focus {
    border-color: #4285f4;
    outline: none;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  color: #666;
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 0 20px 20px 20px;
`;

export const FilterButton = styled.button`
  padding: 8px 16px;
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: ${(props) => (props.active ? '#e8f0fe' : 'white')};
  color: ${(props) => (props.active ? '#1a73e8' : '#666')};
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => (props.active ? '#d2e3fc' : '#f5f5f5')};
  }
`;

export const Table = styled.div`
  width: 100%;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px;
  gap: 16px;
  background-color: #f5f5f5;
  padding: 12px 16px;
  font-weight: 500;
  color: #666;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid #eee;
  align-items: center;

  &:nth-of-type(even) {
    background-color: #fafafa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const AIResponseTextarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    border-color: #4285f4;
    outline: none;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ReviewLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

export const StyledCheckbox = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: ${(props) => (props.checked ? '#4285f4' : 'white')};
  border: 1px solid ${(props) => (props.checked ? '#4285f4' : '#ddd')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #4285f4;
  }
`;

export const CheckIcon = styled.div`
  color: white;
  font-size: 16px;
`;

export const SaveButton = styled.button`
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3367d6;
  }
`;

export const StatusBadge = styled.div`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => (props.edited ? '#e8f0fe' : '#fff3e0')};
  color: ${(props) => (props.edited ? '#1a73e8' : '#f57c00')};
  margin-left: 8px;
`;

export const NoDataMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
`;

export const DateText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
`;
